angular.module('bribac.components.subjectUpload', [
    'bribac.translations',
    'bribac.services.api',
    'bribac.entities.kinds'
])
    .component('subjectUpload', {
        controller: 'SubjectUploadCtrl',
        bindings: {
            onSubjectsUploaded: '&'
        },
        templateUrl: 'subject-upload-component.html'
    })

    .controller('SubjectUploadCtrl', function (
        $http,
        $scope,
        $window,
        KINDS,
        api) {
        const $ctrl = this;

        const BOOLEAN_FIELDS = [
            'show_results_to_subject',
            'require_gps_location',
            'boost_result',
            'notify_passed',
            'notify_failed',
            'notify_expired',
            'notify_failed_optional',
            'notify_passed_optional',
            'notify_when_frs_failed',
            'notify_subject_by_sms',
            'notify_subject_by_email',
            'notify_subject_by_push_message',
            'show_calibration_alerts',
            'save_ruleset_as_template',
            'highlight'
        ];

        $ctrl.componentId = 'csvFileUpload';
        $ctrl.selectedFileName = '';
        $ctrl.subjects = [];

        $ctrl.baseHeaders = [
            'id',
            'first_name',
            'last_name',
            'ssn',
            'address',
            'postal_code',
            'phone',
            'city',
            'email',
            'highlight',
            'locale',
            'organization',
            'main_group',
            'sub_group',
            'time_zone',
            'test_expires_after_seconds',
            'ibac_mac_address',
            'bac_value_limit',
            'bac_unit',
            'show_results_to_subject',
            'require_gps_location',
            'boost_result',
            'notify_passed',
            'notify_failed',
            'notify_expired',
            'notify_failed_optional',
            'notify_passed_optional',
            'notify_when_frs_failed',
            'notify_subject_by_sms',
            'notify_subject_by_email',
            'notify_subject_by_push_message',
            'show_calibration_alerts',
            'save_ruleset_as_template'
        ];

        $ctrl.headers = [...$ctrl.baseHeaders];
        $ctrl.isUploading = false;

        $ctrl.isBooleanField = function (header) {
            if (BOOLEAN_FIELDS.includes(header)) {
                return true;
            }

            if (header.startsWith('schedule_') && (
                header.endsWith('_save_schedule_as_template')
            )) {
                return true;
            }

            return false;
        };

        $ctrl.clickSelectFile = function () {
            document.getElementById($ctrl.componentId).click();
        };

        $ctrl.parseCSV = function (text) {
            const lines = text.split('\n');
            if (lines.length <= 1) return [];

            const csvHeaders = lines[0].split(',').map(h => h.trim());

            $ctrl.headers = csvHeaders;

            const result = lines.slice(1).map(function (line) {
                if (!line) return null;
                const currentline = line.split(',');
                const obj = {};

                csvHeaders.forEach(function (header) {
                    obj[header] = null;
                });

                currentline.forEach(function (value, index) {
                    if (index < csvHeaders.length) {
                        const cleanValue = value.replace(/^["']|["']$/g, '').trim();
                        const header = csvHeaders[index];

                        if (cleanValue === '') {
                            obj[header] = null;
                        } else if ($ctrl.isBooleanField(header)) {
                            obj[header] = cleanValue.toLowerCase() === 'true';
                        } else {
                            obj[header] = cleanValue;
                        }
                    }
                });

                return obj;
            }).filter(Boolean);

            return result;
        };

        function adjustColumnWidths() {
            const table = document.querySelector('.table');
            if (!table) return;

            const headers = table.querySelectorAll('th');
            let totalFrozenWidth = 0;

            headers.forEach((header, index) => {
                const cells = table.querySelectorAll(`td:nth-child(${index + 1})`);
                let maxWidth = header.textContent.length * 8 + 24;

                cells.forEach(cell => {
                    const input = cell.querySelector('input');
                    if (input) {
                        const content = input.value || '';
                        const contentWidth = content.length * 8 + 24;
                        maxWidth = Math.max(maxWidth, contentWidth);
                    }
                });

                maxWidth += 8;

                const finalWidth = `${maxWidth}px`;
                header.style.width = finalWidth;
                header.style.minWidth = finalWidth;
                cells.forEach(cell => {
                    cell.style.width = finalWidth;
                    cell.style.minWidth = finalWidth;
                });

                if (index < 3) {
                    totalFrozenWidth += maxWidth;
                    document.documentElement.style.setProperty(`--col-${index}-width`, `${totalFrozenWidth}px`);
                }
            });
        };

        $ctrl.mapSubjectsToDto = function (subjects) {
            const mappedSubjects = subjects.map(subject => {
                let schedules = [];
                let scheduleIndex = 1;

                while (true) {
                    const prefix = `schedule_${scheduleIndex}_`;
                    const repeatEveryKey = `${prefix}repeat_in_weeks`;
                    const startDateKey = `${prefix}start_date`;
                    const endDateKey = `${prefix}end_date`;

                    const hasRequiredFields =
                        subject[startDateKey] &&
                        subject[endDateKey] &&
                        subject[repeatEveryKey] &&
                        subject[`${prefix}weekdays`];

                    if (!hasRequiredFields) {
                        break;
                    }

                    const maxTestsKey = `${prefix}max_random_tests_per_day`;

                    const schedule = {
                        name: subject[`${prefix}template_name`] || null,
                        template: subject[`${prefix}save_schedule_as_template`] || false,
                        maxRandomTestsPerDay: subject[maxTestsKey] === undefined ? 0 : parseInt(subject[maxTestsKey]),
                        earliestRandom: subject[`${prefix}earliest_random_hour`] || null,
                        latestRandom: subject[`${prefix}latest_random_hour`] || null,
                        weekdays: subject[`${prefix}weekdays`] ?
                            subject[`${prefix}weekdays`].split(';;').filter(Boolean) : [],
                        fixedTimes: parseFixedTimes(subject[`${prefix}fixed_times_with_questions`]),
                        moodQuestions: subject[`${prefix}mood_questions`] ?
                            subject[`${prefix}mood_questions`].split(';;').filter(Boolean) : [],
                        repeatInWeeks: parseInt(subject[repeatEveryKey]),
                        startDate: new Date(subject[startDateKey]),
                        endDate: new Date(subject[endDateKey])
                    };

                    schedules.push(schedule);
                    scheduleIndex++;
                }

                let externalMonitors = [];
                let monitorIndex = 1;

                while (true) {
                    const prefix = `external_monitor_${monitorIndex}_`;
                    const nameKey = `${prefix}name`;

                    if (!subject[nameKey]) {
                        break;
                    }

                    externalMonitors.push({
                        name: subject[nameKey],
                        phone: subject[`${prefix}phone`] || null,
                        email: subject[`${prefix}email`] || null
                    });

                    monitorIndex++;
                }

                return {
                    id: parseInt(subject.id),
                    firstName: subject.first_name,
                    lastName: subject.last_name,
                    ssn: subject.ssn,
                    address: subject.address,
                    postalCode: subject.postal_code,
                    phone: subject.phone,
                    city: subject.city,
                    email: subject.email,
                    locale: subject.locale,
                    organization: subject.organization,
                    highlight: !!subject.highlight,
                    mainGroup: subject.main_group,
                    subGroup: subject.sub_group,
                    timeZone: subject.time_zone,
                    testExpiresAfterSeconds: parseInt(subject.test_expires_after_seconds) || 0,
                    ibac: subject.ibac_mac_address,
                    bacValue: subject.bac_value_limit,
                    bacUnit: subject.bac_unit,
                    showResultsToSubject: !!subject.show_results_to_subject,
                    requireGpsLocation: !!subject.require_gps_location,
                    boostResult: !!subject.boost_result,
                    notifyPassed: !!subject.notify_passed,
                    notifyFailed: !!subject.notify_failed,
                    notifyExpired: !!subject.notify_expired,
                    notifyFailedOptional: !!subject.notify_failed_optional,
                    notifyPassedOptional: !!subject.notify_passed_optional,
                    notifyFrs: !!subject.notify_when_frs_failed,
                    notifySubjectBySms: !!subject.notify_subject_by_sms,
                    notifySubjectByMail: !!subject.notify_subject_by_email,
                    notifySubjectByPush: !!subject.notify_subject_by_push_message,
                    showCalibration: !!subject.show_calibration_alerts,
                    template: !!subject.save_ruleset_as_template,
                    rulesetTemplateName: subject.ruleset_template_name || null,
                    schedules: schedules,
                    externalMonitors: externalMonitors
                };
            });

            return {
                subjects: mappedSubjects
            };
        };

        function parseFixedTimes(fixedTimesStr) {
            if (!fixedTimesStr) return [];

            return fixedTimesStr.split(';;')
                .map(timeEntry => {
                    const parts = timeEntry.split('::');
                    if (parts.length === 1) {
                        return {
                            time: parts[0],
                            question: null
                        };
                    }
                    return {
                        time: parts[0],
                        question: parts[1]
                    };
                });
        }

        $ctrl.uploadSubjects = function () {
            $ctrl.isUploading = true;
            const requestBody = $ctrl.mapSubjectsToDto($ctrl.subjects);

            api.post(KINDS.SUBJECTS_UPLOAD, requestBody)
                .then(function (response) {
                    if (response.data.errors && response.data.errors.length) {
                        $ctrl.errors = response.data.errors;
                    } else {
                        $ctrl.errors = null;
                        $ctrl.subjects = [];
                        $ctrl.selectedFileName = '';
                    }

                    if ($ctrl.onSubjectsUploaded) {
                        $ctrl.onSubjectsUploaded({
                            subjects: $ctrl.subjects,
                            response: response
                        });
                    }
                })
                .catch(function (error) {
                    $ctrl.errors = error.data && error.data.errors ? error.data.errors : ['Upload failed. Please try again.'];

                    if ($ctrl.onSubjectsUploaded) {
                        $ctrl.onSubjectsUploaded({
                            subjects: $ctrl.subjects,
                            response: {
                                data: {
                                    errors: $ctrl.errors
                                }
                            }
                        });
                    }
                })
                .finally(function () {
                    $ctrl.isUploading = false;
                });
        };

        $ctrl.$onInit = function () {
            if (!$ctrl.onSubjectsUploaded) {
                console.warn('No onSubjectsUploaded callback provided to subject-upload component');
            }

            const resizeObserver = new ResizeObserver(adjustColumnWidths);
            const tableContainer = document.querySelector('.table-container');
            if (tableContainer) {
                resizeObserver.observe(tableContainer);
            }

            $scope.$on('$destroy', function () {
                resizeObserver.disconnect();
            });

            $ctrl.errors = null;
            $ctrl.successMessage = null;
        };
        $ctrl.onSubjectBlur = function (subject) {
            adjustColumnWidths();
        };

        $ctrl.handleFileChange = function (element) {
            const file = element.files[0];
            if (file) {
                $ctrl.selectedFileName = file.name;
                const reader = new FileReader();

                reader.onload = function (e) {
                    const text = e.target.result;
                    $ctrl.subjects = $ctrl.parseCSV(text);

                    $scope.$apply();

                    setTimeout(adjustColumnWidths, 100);
                };

                reader.readAsText(file);
            }
        };

        angular.element($window).on('resize', adjustColumnWidths);

        $scope.$on('$destroy', function () {
            angular.element($window).off('resize', adjustColumnWidths);
        });

        $ctrl.onSubjectChange = function (subject) {
            setTimeout(adjustColumnWidths, 0);
        };
    });